const googleMapsLatLngUrl = (latitude: number, longitude: number) =>
    `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

export default googleMapsLatLngUrl;
